import { useFlags } from 'launchdarkly-react-client-sdk';
import { Ticket } from 'types/domain';

interface TicketSeatingInfoProps {
    ticket: Ticket;
}

const TicketSeatingInfo = ({ ticket }: TicketSeatingInfoProps) => {
    const { tableSeating = false } = useFlags();
    if (!tableSeating) {
        return null;
    }

    if (!ticket.seating_group && !ticket.ticket_group) {
        return null;
    }

    return (
        <div className={'flex'}>
            {ticket.ticket_group?.name && (
                <div className={'flex flex-1 flex-col'}>
                    <p className={'text-sm text-gray-600'}>Ticket group</p>
                    <p className={'text-sm font-medium text-gray-800'}>
                        {ticket.ticket_group.name}
                    </p>
                </div>
            )}
            {ticket.seating_group?.name && (
                <div className={'flex flex-1 flex-col'}>
                    <p className={'text-sm text-gray-600'}>Seating info</p>
                    <p className={'text-sm font-medium text-gray-800'}>
                        {`${ticket.seating_group?.name}${ticket.seat_number > 0 ? ', Seat ' + ticket.seat_number : ''}`}
                    </p>
                </div>
            )}
        </div>
    );
};

export { TicketSeatingInfo };
